<template>
  <audio
    preload="auto"
    loop
    id="audio"
    :src="music_url"
  ></audio>
  <div @click="changeOn" :class="isOff ? 'isOff' : 'isOn'"></div>
  <router-view />
</template>

<script>
import { onMounted, ref, provide} from "vue";
export default {
  setup() {
    let isOff = ref(true);
    const music_url = ref(require('./assets/images/bgmusic.mp3'));
    const changeOn = (status) => {
      let oAudio = document.querySelector("#audio");
      if(status === "on") {
        isOff.value = false;
        oAudio.play();
      } else if(status === "off") { 
        oAudio.pause();
        isOff.value = true;
      } else {
        if (isOff.value) {
          oAudio.play(); //让音频文件开始播放
        } else {
          oAudio.pause(); //让音频文件暂停播放
        }
        isOff.value = !isOff.value;
       }
    };
    provide("changeOn", changeOn)
    const audioAutoPlay = () => {
      let audio = document.getElementById("audio");
      isOff.value = false;
      audio.play();
      document.removeEventListener("touchstart", audioAutoPlay);
    };
    onMounted(() => {
      document.addEventListener("touchstart", audioAutoPlay, false);
      document.addEventListener("WeixinJSBridgeReady", audioAutoPlay, false);
      let oAudio = document.querySelector("#audio");
      oAudio.onended = function () {
        //播放完毕，重新循环播放
        oAudio.load();
        oAudio.play();
      };
    });
    return { changeOn, isOff, music_url };
  },
};
</script>

<style lang="stylus">
  /* 设置基础宽度 */
  #app {
    max-width: 768px; /* 通常移动端设备的宽度 */
    margin: 0 auto;
    position: relative
  }
  
  /* 当屏幕宽度大于768px时，为PC端调整宽度 */
  @media (min-width: 768px) {
    #app {
      max-width: 768px; /* 或者你希望的任何PC端宽度 */
    }
  }
.isOn{
  width: 60px;
  height: 60px;
  position: absolute;
  z-index: 2000;
  top: 40px;
  right: 40px;
  -webkit-animation: rotating 1.2s linear infinite;
  animation: rotating 1.2s linear infinite;
  background: url("./assets/images/yf-01.png") 0 0 no-repeat;
  background-size:100%;
}
@keyframes rotating {
  from { -webkit-transform: rotate(0) }
  to { -webkit-transform: rotate(360deg) }
}
@-webkit-keyframes rotating {
  from { -webkit-transform: rotate(0) }
  to { -webkit-transform: rotate(360deg) }
}
.isOff{
  position: absolute;
  width: 60px;
  height: 60px;
  z-index: 2000;
  top: 40px;
  right: 40px;
  background: url("./assets/images/yf-02.png") 0 0 no-repeat;
  background-size:100%;
}
</style>
